import usePermissionsStore from '@/stores/usePermissionsStore'
import { resources, scopes } from '@/utils/permission'

const useAffiliatePolicyPermissions = () => {
    const { permissions, isAdmin } = usePermissionsStore()
    const affiliateScopes =
        permissions.find(
            (permission) => permission?.rsname === resources.affiliates
        )?.scopes || []

    // The API gates affiliate routes on the `Affiliates` resource, and also widens to accept
    // Customers create/update (CSKH, BOM, Sale) as a fallback. Mirror that here: anyone who can
    // write customers gets the affiliate action surfaces, matching what the backend actually allows.
    const customerScopes =
        permissions.find(
            (permission) => permission?.rsname === resources.customers
        )?.scopes || []
    const canWriteCustomers =
        customerScopes.includes(scopes.create) ||
        customerScopes.includes(scopes.update)

    const hasScope = (scope: string) =>
        isAdmin || affiliateScopes.includes(scope) || canWriteCustomers

    const canCreate = hasScope(scopes.create)
    const canUpdate = hasScope(scopes.update)
    const canDelete = hasScope(scopes.delete)

    return {
        canCreatePolicy: canCreate,
        canUpdatePolicy: canUpdate,
        canDeletePolicy: canDelete,
        // Every payout transition (approve/complete/reject) and the affiliate
        // inline edit go through endpoints the API guards with Affiliates:update.
        canUpdateAffiliate: canUpdate,
        // Commission policies are an admin-side surface: a read-only viewer
        // (index/show only) must not even see the tab.
        canManagePolicies: canCreate || canUpdate,
    }
}

export default useAffiliatePolicyPermissions
